import * as helper from './../../../Assets/Js/helper';

export interface Clip {
	title: string
	host: string
	preview: string
	video: string
}

export function ClipHandler(node:HTMLElement) {
	if (node === null) {
		return;
	}

	const clips: Clip[] = JSON.parse(helper.getData(node, 'clips'));
	const leftImage:HTMLDivElement = node.querySelector('.left .preview-image');
	const rightImage:HTMLDivElement = node.querySelector('.right .preview-image');
	const leftArrow = node.querySelector('.left a');
	const rightArrow = node.querySelector('.right a');
	const video = node.querySelector('video');
	const name:HTMLDivElement = node.querySelector('.name');

	let currentClip = 1;

	const updateHandler = () => {
		let previousClip = currentClip - 1;
		let nextClip = currentClip + 1;

		if (previousClip < 0) {
			previousClip = clips.length - 1;
		}
		if (nextClip > clips.length - 1) {
			nextClip = 0;
		}

		name.innerText = clips[currentClip].host;
		leftImage.style.backgroundImage = 'url(' + clips[previousClip].preview + ')';
		rightImage.style.backgroundImage = 'url(' + clips[nextClip].preview + ')';
		video.src = clips[currentClip].video;
		video.poster = clips[currentClip].preview;
		video.play();
	}

	const previousHandler = (evt:MouseEvent) => {
		evt.preventDefault();
		currentClip--;
		if (currentClip < 0) {
			currentClip = clips.length - 1;
		}
		updateHandler();
	}

	const nextHandler = (evt:MouseEvent) => {
		evt.preventDefault();
		currentClip++;
		if (currentClip > clips.length - 1) {
			currentClip = 0;
		}
		updateHandler();
	}

	helper.addEventListener(leftArrow, 'click', previousHandler);
	helper.addEventListener(rightArrow, 'click', nextHandler);
}
